module.exports = __webpack_public_path__ + "static/media/icon_share_email.a9cea4f6.svg";